// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Field, reduxForm } from "redux-form";
import type { FormProps } from "redux-form";
import { TextField, DatePickerFormWrapper } from "@components/form";
import { Form, FormGroup, Label, Button } from "@components";

type Props = $Exact<{
  onSubmit: (formData: Object) => void,
  onChange: (formData: Object) => void,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
  ...PropsFromLocalize,
}>;

export class Step1SelectEmployeeFilter extends React.Component<Props> {
  handleReset = () => {
    this.props.reset();
    this.props.onReset();
  };

  get notificationTypeOptions() {
    return this.props.notificationTypes.map(type => ({
      value: type.const,
      label: type.title,
    }));
  }

  render() {
    return (
      <Form
        className="row align-items-end filters"
        onChange={this.props.handleChange}
        onSubmit={this.props.handleSubmit}
      >
        <FormGroup className="col-3 pl-0">
          <Label for="lastName" className="mr-sm-2">
            {this.props.t("SURNAME")}
          </Label>
          <Field id="lastName" name="lastName" className="w-100" component={TextField} />
        </FormGroup>
        <FormGroup className="col-3">
          <Label for="employeeRefPrimary" className="mr-sm-2">
            {this.props.t("EMPLOYEE_REF")}
          </Label>
          <Field
            id="employeeRefPrimary"
            name="employeeRefPrimary"
            className="w-100"
            component={TextField}
          />
        </FormGroup>
        <FormGroup className="col-3">
          <Label for="dateOfBirth" className="mr-sm-2">
            {this.props.t("DATE_OF_BIRTH")}
          </Label>
          <Field
            name="dateOfBirth"
            className="w-100"
            component={DatePickerFormWrapper}
            customProps={{ id: "dateOfBirth" }}
          />
        </FormGroup>
        <div className="d-flex">
          <Button
            className="mt-3 form-group"
            onClick={this.props.handleSubmit}
            materialIcon="replay_circle_filled"
          >
            {this.props.t("SUBMIT")}
          </Button>
          {this.props.dirty ? (
            <Button className="mt-3 form-group" color="secondary" onClick={this.handleReset}>
              {this.props.t("RESET")}
            </Button>
          ) : null}
        </div>
      </Form>
    );
  }
}

export default reduxForm({
  form: "step1-select-employee-filter",
})(localize()(Step1SelectEmployeeFilter));
